<template>
  <img
    v-if="image && !imageFailed"
    :src="image.url"
    class="avatar rounded-circle"
	:class="{ 'bg-darkish': dark }"
    style="object-fit: contain;"
	:style="{ width: getSize(size), height: getSize(size) }"
	loading="lazy"
	@error="imageFailed = true"
  />
  <div
    v-else
    class="avatar text-white rounded-circle d-inline-flex flex-column flex-shrink-0 align-items-center justify-content-center"
	:class="{ 'small': size === 'sm' }"
    :style="{
        backgroundColor: getFallbackBackgroundColor(),
		width: getSize(size), 
		height: getSize(size)
    }"
  >
	<span
		class="d-inline-flex align-items-center justify-content-center w-100 h-100"
		:style="fallbackTextStyle"
	>
		{{ fallback.substring(0, 2) }}
	</span>
  </div>
</template>
<script>
import { stringToColor } from '~/util/helpers'
export default {
	props: {
		image: {
			type: Object,
			default: null
		},

		fallback: {
			type: String,
			default: ''
		},
		fallbackBackgroundColor: {
			type: String,
			default: null
		},

		dark: {
			type: Boolean,
			default: false
		},

		size: {
			type: String,
			default: null
		}
	},
	computed: {
		fallbackTextStyle() {
			return {
				color: 'var(--Color-Solid-White, #FFF)',
				textAlign: 'center',
				fontFamily: 'Roboto',
				fontSize: '12px',
				fontStyle: 'normal',
				fontWeight: 500,
				lineHeight: 'normal',
				letterSpacing: '0'
			}
		}
	},

	data() {
		return {
			imageFailed: false
		}
	},

	methods: {
		stringToColor(input) {
			return stringToColor(input)
		},
		getFallbackBackgroundColor() {
			if (this.fallbackBackgroundColor) {
				return this.fallbackBackgroundColor
			}

			return stringToColor(this.fallback)
		},

		getSize(size) {
			if (typeof size === 'string' && /^\d+(\.\d+)?(px|rem|em|%)$/.test(size)) {
				return size
			}

			if (size === 'sm') {
				return '1.5rem'
			}

			return '2.5rem'
		}
	}
}
</script>
